<app-mainscreen>
    <div class="view_box_container">
        <div class="">
            <div class="row">
                <div class="col-lg-8 col-md-8 col-sm-8 col-12">
                    <div class="view_div">
                        <div class="row align-items-center justify-content-start">
                            <div class="w-auto">
                                <div class="view_block">
                                    <ul>
                                        <li>
                                            <div class="d-flex justify-content-between">
                                                <img class="img-fluid w-auto h-50px" title="{{insuranceFormControl['insuranceName'].value}}" alt="{{insuranceFormControl['insuranceName'].value}}" src="/assets/images/insurance_companies/f_{{insuranceFormControl['insuranceId'].value}}.png">
                                                <div class="text-center">
                                                    <label class="w-100 mb-0 d-flex align-items-center">Status <span title="Edit Status" class="material-symbols-outlined font-20 ml-1" (click)="insuranceCompanyConfirmationModalShow = true"> edit_square </span></label>                                                    
                                                    <label class="w-auto mb-0 status" [ngClass]="insuranceFormControl['insuranceStatus'].value == false ? 'inactive' : 'active'"> {{insuranceFormControl['insuranceStatus'].value == false ? 'Inactive' : 'Active'}}</label>
                                                </div>
                                            </div>
                                            <p class="mb-0">{{insuranceFormControl['insuranceName'].value}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!-- <div class="w-auto">
                                <div class="view_block">
                                    <label class="label_13_grey3 d-inline-flex align-items-center"><span class="material-symbols-outlined font-18 "> corporate_fare </span>&nbsp; Provider Status : </label> <span class="status"> {{insuranceFormControl['insuranceStatus'].value == true ? 'Active' : 'Inactive'}}</span> <br>
                                    <label class="label_13_grey3 d-inline-flex align-items-center"><span class="material-symbols-outlined font-18"> calendar_today </span> &nbsp; Integration Date : </label> <span class="label_13_grey2">{{insuranceFormControl['createdDate'].value}}</span>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div class="view_buttons d-flex justify-content-end pt-0">
                        <app-custom-button className="bg-secondary" text="Back" [width]="'auto'" [height]="'34px'" leadingIconName="list" (click)="homeBtClick()">Back</app-custom-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="box_container mt-3"> 
        <div class="row w-100">
            <div class="col-md-4 border-right">
                <form id="kt_account_profile_details_form" class="form" [formGroup]="insuranceForm" novalidate="novalidate">
                    <div class="box_header pb-0">
                        <span class="box_title_18">
                            Provider Details
                        </span>           
                    </div>
                    <div class="p-lr-10">
                        <label class="box_title_18 border_top_grey5 w-100 mb-0 pb-2"></label>                
                        <div class="row">
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['contactNumber'].touched  || submittedInsForm) && !insuranceFormControl['contactNumber'].valid)}">
                                <input type="text" id="contactNumber" name="contactNumber" placeholder=" " class="form-control input_ tp" formControlName="contactNumber"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['contactNumber'].touched  || submittedInsForm) && insuranceFormControl['contactNumber'].errors?.['required'])}"
                                 (keypress)="numberOnly($event)" maxlength="10" minlength="10" onKeyPress="if(this.value.length==10) return false;">
                                <label for="contactNumber" class="label_">Contact Number</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['contactNumber'].touched || submittedInsForm) && insuranceFormControl['contactNumber'].errors?.['required'])">
                                    Contact number is required.
                                </Span>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['contactNumber'].touched || submittedInsForm) && insuranceFormControl['contactNumber'].errors?.['pattern'])">
                                    Please provide valid mobile number.
                                </Span>
                            </div>
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['email'].touched  || submittedInsForm) && !insuranceFormControl['email'].valid)}">
                                <input type="text" id="email" name="email" placeholder=" " class="form-control input_ tp" formControlName="email"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['email'].touched  || submittedInsForm) && insuranceFormControl['email'].errors?.['required'])}">
                                <label for="email" class="label_">Email Id</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['email'].touched  || submittedInsForm) && insuranceFormControl['email'].errors?.['required'])">
                                    Email id is required.
                                </Span>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['email'].touched || submittedInsForm) && insuranceFormControl['email'].errors?.['pattern'])">
                                    Please provide valid mobile number.
                                </Span>
                            </div>
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['whatsAppNumber'].touched  || submittedInsForm) && !insuranceFormControl['whatsAppNumber'].valid)}">
                                <input type="text" id="whatsAppNumber" name="whatsAppNumber" placeholder=" " class="form-control input_ tp" formControlName="whatsAppNumber"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['whatsAppNumber'].touched  || submittedInsForm) && insuranceFormControl['whatsAppNumber'].errors?.['required'])}"
                                (keypress)="numberOnly($event)" maxlength="10" onKeyPress="if(this.value.length==10) return false;">
                                <label for="whatsAppNumber" class="label_">whatsApp Number</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['whatsAppNumber'].touched || submittedInsForm) && insuranceFormControl['whatsAppNumber'].errors?.['pattern'])">
                                    Please provide valid whatsApp number.
                                </Span>
                            </div>
                            <div class="col-12 position-relative" [ngClass]="{'mb-2':((insuranceFormControl['address'].touched  || submittedInsForm) && !insuranceFormControl['address'].valid)}">
                                <textarea id="address"  rows="5" name="address" placeholder=" " class="form-control input_ tp" formControlName="address" (keypress)="alphaNumericWithSpacesSlaceHyphenComma($event)"
                                [ngClass]="{'border border-danger': ((insuranceFormControl['address'].touched  || submittedInsForm) && insuranceFormControl['address'].errors?.['required'])}"></textarea>
                                <label for="address" class="label_ ta5">Address</label>
                                <Span class="text-danger error_span" *ngIf="((insuranceFormControl['address'].touched  || submittedInsForm) && insuranceFormControl['address'].errors?.['required'])">
                                    Address number is required.
                                </Span>
                            </div>
                            <div class="col-12 text-end">
                                <app-custom-button className="" text="Update Details" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="saveProviderDetails()"></app-custom-button>   
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-8">
                <div class="box_header pb-0">
                    <span class="box_title_18">
                        Product & Plan Configuration
                    </span>   
                    <app-custom-button className="" text="Update Plan Configuration" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="planConfigurationConfirmationModalShow = true;">Update Plan Configuration</app-custom-button>        
                </div>
                <div class="p-lr-10">
                    <label class="box_title_18 border_top_grey5 w-100 mb-0 pb-2"></label> 
                    <div class="row">
                        <ng-container *ngFor="let product of insuranceStatus">
                            <div class="col-md-6 mb-2">                                
                                <div class="card min-h-102">
                                    <div class="d-flex py-1 px-2 justify-content-between border-bottom align-items-center">
                                        <div>
                                            <img src="/assets/images/insurance_product/P_30X20_{{product.productId}}.svg">
                                            <span class="ml-2">{{product.productName}}</span>
                                        </div>
                                        <app-toggle-switch [showPopup]="true" [comment]="''"  [isCommentRequired]="true" [popupTitle]="'Are you sure!'"  [popupSubTitle]="this.getSubTitleContent(product.status??false,product.productName??'')"  [data]="product" (toggleChanged)="toggleChanged($event)" [switchon]="product.status??false" class=""></app-toggle-switch>
                                    </div>
                                    <div class="plan-container px-2 pt-3">
                                        <div class="w-100 position-static">
                                            <app-multi-dropdown  class="w-100 input_"
                                                [items]="product.insuranceProductsPlanListItemObj??[]" 
                                                [showSearch]="true" 
                                                [showAll]="true" 
                                                [showStatus]="false"
                                                [showError]="false" 
                                                placeholder="Plan" 
                                                [isReadOnly]="(product.status??false) == false"
                                                className=""
                                                ddlClassName = "position-static"
                                                fontColor="var(--grey3)"
                                                fontSize="15px"
                                                id="InsurancePlans_{{product.productId}}"
                                                (itemChange)="onInsuranceCopanyPlanSelect($event,product.productId??0)">
                                            </app-multi-dropdown>
                                            <label class="label_">Plan Configuration</label>
                                        </div>
                                        <ng-container *ngFor="let plan2 of product.insuranceProductsPlanList">
                                            <label>{{plan2.planDescription}}</label>
                                        </ng-container>
                                    </div>                                                                       
                                </div>
                            </div>
                        </ng-container>
                    </div>  
                </div>  
            </div>
        </div>
    </div>

    <div class="overlay" *ngIf="planConfigurationConfirmationModalShow">
        <div class="popup2 position-relative col-md-4">
            <div class="modal-header tooltip_ bg-transparent border-bottom">
                <!-- <h4 class="modal-title">Sign In</h4> -->
                <h3 class="h5">Are you sure!</h3>
                <button type="button" class="close pull-right" aria-label="Close"  (click)="planConfigurationConfirmationModalShow=false;">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body pt-2">
                <p class="text-grey4">
                    Are you sure you want to update Plans configuration?
                </p>
                <textarea id="comment"  rows="5" name="comment" placeholder=" " class="form-control input_" [(ngModel)]="planConfigurationComment"
                    [ngClass]="{'border border-danger': (planConfigurationCommentFormSubmitted  && planConfigurationComment == '')}">
                </textarea>
                <label for="address" class="label_ ta5 required">Comment</label>
                <Span class="text-danger error_span pl-2 " *ngIf="(planConfigurationCommentFormSubmitted && planConfigurationComment == '')">
                    Comment is required.
                </Span>
                <div class="row">
                    <div class="col-6">
                        <app-custom-button className="w-100 justify-content-center" text="No" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="planConfigurationConfirmationModalShow=false;"></app-custom-button> 
                    </div>
                    <div class="col-6">
                        <app-custom-button className="w-100 justify-content-center btn_outline" text="Yes" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="planConfigurationCommentFormSubmitted = true; updatePlanConfiguration();"></app-custom-button> 
                    </div>
                </div>    
            </div>
        </div>
    </div>

    <div class="overlay" *ngIf="insuranceCompanyConfirmationModalShow">
        <div class="popup2 position-relative col-md-4">
            <div class="modal-header tooltip_ bg-transparent border-bottom">
                <!-- <h4 class="modal-title">Sign In</h4> -->
                <h3 class="h5">Are you sure!</h3>
                <button type="button" class="close pull-right" aria-label="Close"  (click)="insuranceCompanyConfirmationModalShow=false;">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body pt-2">
                <p class="text-grey4">
                    Are you sure you want to mark this insurance provider as {{insuranceFormControl['insuranceStatus'].value == true ? 'Inactive' : 'Active'}}?
                </p>
                <textarea id="comment"  rows="5" name="comment" placeholder=" " class="form-control input_" [(ngModel)]="insuranceCompanyComment"
                    [ngClass]="{'border border-danger': (insuranceCompanyCommentFormSubmitted  && insuranceCompanyComment == '')}">
                </textarea>
                <label for="address" class="label_ ta5 required">Comment</label>
                <Span class="text-danger error_span pl-2 " *ngIf="(insuranceCompanyCommentFormSubmitted && insuranceCompanyComment == '')">
                    Comment is required.
                </Span>
                <div class="row">
                    <div class="col-6">
                        <app-custom-button className="w-100 justify-content-center" text="No" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="planConfigurationConfirmationModalShow=false;"></app-custom-button> 
                    </div>
                    <div class="col-6">
                        <app-custom-button className="w-100 justify-content-center btn_outline" text="Yes" [width]="'auto'" [height]="'34px'" leadingIconName="" (click)="insuranceCompanyCommentFormSubmitted = true; updateInsuracneCompanyStatus();"></app-custom-button> 
                    </div>
                </div>    
            </div>
        </div>
    </div>
    </app-mainscreen>